import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BomAttachmentDto } from './bom-attachment.dto';

@Injectable({ providedIn: 'root' })
export class BomAttachmentsProvider {
  constructor(private http: HttpClient) {}

  getAttachments(bomItemId: number): Observable<BomAttachmentDto[]> {
    const url = `/api/bom/${bomItemId}/attachments`;
    return this.http.get<BomAttachmentDto[]>(url);
  }

  uploadAttachment(bomItemId: number, file: File): Observable<BomAttachmentDto> {
    const url = `/api/bom/${bomItemId}/attachments`;
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<BomAttachmentDto>(url, formData);
  }

  deleteAttachment(attachmentId: number): Observable<void> {
    const url = `/api/bom/attachments/${attachmentId}`;
    return this.http.delete<void>(url);
  }

  setPrimaryPhoto(attachmentId: number): Observable<void> {
    const url = `/api/bom/attachments/${attachmentId}/primary`;
    return this.http.patch<void>(url, null);
  }

  contentUrl(attachmentId: number): string {
    return `/api/bom/attachments/${attachmentId}/content`;
  }
}
